import { render, staticRenderFns } from "./AccountTypesViewUserTemplates.vue?vue&type=template&id=795b6be8&lang=pug&"
import script from "./AccountTypesViewUserTemplates.vue?vue&type=script&lang=js&"
export * from "./AccountTypesViewUserTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports